<template>
  <div>
    <div v-if="ingresso()">
      <p
        class="mb-3 grey--text text--darken-2"
        data-cy="label_texto_curso"
      >
        Gere seu ingresso digital e garanta acesso ao evento!
      </p>
      <v-btn
        :href="dadosIngresso"
        block
        class="mb-2"
        :class="!$vuetify.breakpoint.mdAndDown || 'body-2 px-0'"
        color="primary"
        data-cy="ingresso_digital_url"
        target="_blank"
        @click="scoreConsumidor(dados.id)"
      >
        Ingresso Digital
      </v-btn>

      <TitularidadeIngressoModal :venda="this.dados.id" />
    </div>

    <div v-else-if="orderBump()">
      <p
        class="primary--text mb-5 font-weight-bold text-uppercase"
        data-cy="order_bump_titulo"
      >
        Compra conjunta
      </p>
      <p
        class="mb-3 grey--text text--darken-2"
        data-cy="order_bump_texto"
      >
        Você adquiriu mais de um produto nesta mesma compra.
      </p>
      <v-chip
        class="primary--text order-bump__tag justify-center mb-1"
        data-cy="order_bump_tag"
        label
        outlined
      >
        {{ dados.total_order_bump_items | fraseOrderBump }}
      </v-chip>
    </div>

    <InfoAcompanharEnvio
      v-else-if="dados.tracking_code"
      :codigo-rastreio="dados.tracking_code"
      :servico-rastreio="dados.tracking_service_slug || ''"
      :transportadora-nome="dados.tracking_service_name"
      :venda-id="dados.id"
      @gravar-compra-store="gravarDadosCompra(dados)"
    />

    <div v-else-if="entrega()">
      <p
        class="primary--text mb-3 font-weight-bold text-uppercase"
        data-cy="label_endereco_de_entrega"
      >
        Endereço de entrega
      </p>
      <p
        class="mb-0 grey--text text--darken-2"
        data-cy="entrega_endereco"
      >
        {{ dadosEntrega.address }},
        {{ dadosEntrega.number }}
      </p>
      <p
        v-if="dadosEntrega.complement"
        class="mb-0 grey--text text--darken-2"
        data-cy="entrega_complemento"
      >
        {{ dadosEntrega.complement }}
      </p>
      <p
        class="mb-0 grey--text text--darken-2"
        data-cy="entrega_bairro"
      >
        {{ dadosEntrega.neighbourhood }},
        {{ dadosEntrega.city }},
        {{ dadosEntrega.state }}
      </p>
      <p
        class="mb-0 grey--text text--darken-2"
        data-cy="entrega_cep"
      >
        CEP {{ dadosEntrega.zipcode }}
      </p>
    </div>

    <div v-else-if="curso()">
      <p
        class="mb-3 grey--text text--darken-2"
        data-cy="label_texto_curso"
      >
        Acesse seu conteúdo de qualquer lugar e bons estudos!
      </p>
      <v-btn
        :href="dadosCurso.course_link"
        block
        :class="!$vuetify.breakpoint.mdAndDown || 'body-2 px-0'"
        color="primary"
        data-cy="curso_url"
        target="_blank"
        @click="scoreConsumidor(dados.id)"
      >
        Acessar meu conteúdo
      </v-btn>
    </div>

    <div v-else-if="download()">
      <p
        class="mb-3 grey--text text--darken-2"
        data-cy="label_texto_curso"
      >
        Encontre aqui os arquivos disponibilizados pelo vendedor.
      </p>
      <BtnBaixarAquivos
        :downloads="dadosDownload.downloads"
        :venda-id="dados.id"
        card-desktop
      />
    </div>
  </div>
</template>

<script>
import api from '@/api';
import BtnBaixarAquivos from '@/components/Compras/BtnBaixarAquivos.vue';
import InfoAcompanharEnvio from '@/components/Compras/InfoAcompanharEnvio.vue';
import { mapActions } from 'vuex';
import TitularidadeIngressoModal from './TitularidadeIngresso/TitularidadeIngressoModal.vue';

export default {
  name: 'InfoProduto',

  components: {
    BtnBaixarAquivos,
    InfoAcompanharEnvio,
    TitularidadeIngressoModal,
  },

  filters: {
    fraseOrderBump(value) {
      if (value === 1) {
        return '+ 1 item';
      }
      return `+ ${value} itens`;
    },
  },

  props: {
    dados: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      dadosEntrega: {},
      dadosCurso: {},
      dadosDownload: {},
      dadosIngresso: '',
    };
  },

  methods: {
    ...mapActions(['gravarDadosCompra']),

    async scoreConsumidor(orderId) {
      await api.post('/consumer_score', {
        action: 'membertizze_digital_products',
        orderId,
      });
    },

    entrega() {
      const dados = this.dados.shipping_address;
      if (dados && dados.products.length > 0) {
        this.dadosEntrega = this.dados.shipping_address;
        return true;
      }
      return false;
    },

    curso() {
      const dados = this.dados.products;
      const cursos = [];
      let retorno = false;

      if (dados) {
        dados.forEach((produto) => {
          if (produto.course_link) {
            retorno = true;
            cursos.push(produto);
          }
        });
      }

      this.dadosCurso = cursos.length > 0 ? cursos[0] : {};

      return retorno;
    },

    orderBump() {
      const quantidade = this.dados.total_order_bump_items || 0;
      if (quantidade > 0) return true;
      return false;
    },

    download() {
      const dados = this.dados.products;
      const download = [];
      let retorno = false;

      if (dados) {
        dados.forEach((produto) => {
          if (produto.downloads.length) {
            retorno = true;
            download.push(produto);
          }
        });
      }

      this.dadosDownload = download.length > 0 ? download[0] : {};

      return retorno;
    },

    ingresso() {
      const { ticket_link: dados } = this.dados;
      if (dados) {
        this.dadosIngresso = dados;
        return true;
      }
      return false;
    },
  },
};
</script>

<style lang="scss">
.order-bump__tag { width: 100% !important; }
.v-text-field > .v-input__control > .v-input__slot:before,
.v-text-field > .v-input__control > .v-input__slot:after {
  border-style: none!important;
}
.v-input input[type=text]{color: inherit!important;cursor: pointer;}
</style>
